var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1C16.8922 1 18.7247 1.37068 20.4502 2.10059C22.0127 2.76142 23.4255 3.6888 24.6562 4.8623L24.9004 5.10059C26.187 6.38758 27.1964 7.88397 27.9014 9.55078C28.6308 11.2755 28.9999 13.1076 29 15C29 16.8921 28.6298 18.7242 27.9004 20.4492C27.1954 22.1162 26.1863 23.6135 24.8994 24.9004C23.6125 26.1869 22.1159 27.1955 20.4492 27.9004C18.7241 28.6299 16.8922 29 15 29C13.1078 29 11.2759 28.6299 9.55078 27.9004C7.88395 27.1955 6.38742 26.1871 5.10059 24.9004C3.81392 23.6134 2.80455 22.1161 2.09961 20.4492C1.3702 18.7242 1 16.8921 1 15C1.00005 13.2263 1.32579 11.5057 1.96777 9.87598L2.10059 9.55078C2.80553 7.88394 3.8138 6.38742 5.10059 5.10059C6.38756 3.81397 7.884 2.80455 9.55078 2.09961C11.2758 1.37011 13.1079 1.00005 15 1Z",
    fill: "white",
    stroke: "#CFCFCF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTick);
export default __webpack_public_path__ + "static/media/no-tick.cfc7835f82c85e761dcb362d3dba3740.svg";
export { ForwardRef as ReactComponent };